/*
=========================================================
* CarbonAGX Website
=========================================================
* 
* Copyright 2022 CarbonAGX
=========================================================
* 
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Images
import bgImage from "assets/images/money-trees.jpg";
import CalcWidget from "./CalcWidget";
import { useEffect } from "react";
function Calculator() {
  useEffect(() => {
    document.title = "CarbonAGX Calculator";  
  }, []);
  return (
    <>

        <Container>
          <Grid
            container
            item
            xs={12}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} alignContent="center">
              <Typography display="inline" align="center" variant="h3" color="white" mt={16} mb={13}>
                CarbonAGX Calculator<sup style={{ fontSize: 10 }}>TM</sup>
              </Typography>
            </Grid>
          </Grid>
        </Container>

      <Card
        sx={{
          p: 2,
          pb: 10,
          mx: { xs: 0, sm: 2, lg: 3 },
          mt: { xs: -10, md: -8 },
          mb: 4,
          backgroundColor: ({ palette: { light }, functions: { rgba } }) => rgba(light.main, 1),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >

          <Container>
            <CalcWidget />
          </Container>

      </Card>
    </>
  );
}

export default Calculator;
